export const NUMERIC = 'numeric'
export const ALPHANUMERIC = 'alphanumeric'
export const ALPHABETIC = 'alphabetic'
export const EXPIRATION = 'expiration'
export const SECURITY_CODE = 'security-code'
export const ZIP = 'zip'
export const NONE = 'none'
export const USD = 'usd'

export const INPUT_VALIDATOR_TYPES = {
	NUMERIC,
	ALPHANUMERIC,
	ALPHABETIC,
	EXPIRATION,
	SECURITY_CODE,
	ZIP,
	NONE,
	USD
} as const

export type InputRestriction = typeof INPUT_VALIDATOR_TYPES[keyof typeof INPUT_VALIDATOR_TYPES]
